import gql from 'graphql-tag';

export const FETCH_OPERATION_HOURS = gql`
  query(
    $contractId: Int!
    $startTimestamp: Float!
    $endTimestamp: Float!
  ) {
    getOperationHours(
      contractId: $contractId
      startTimestamp: $startTimestamp
      endTimestamp: $endTimestamp
    ) {
      timeSlots {
        from
        to
      }
    }
  }
`;
